var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.active,"can-cancel":false,"is-full-page":false},on:{"update:active":function($event){_vm.active=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }